import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	compactContainer: {
		...CssSelectors.allChildren(
			{
				height: '100%',
				width: 180,
				marginLeft: -60,
				marginTop: -70,
			},
			'svg'
		),
	},
	container: {
		cursor: 'pointer',
		overflow: 'hidden',
		position: 'relative',
	},
	title: {
		color: brandPrimary,
		fontSize: 18,
		left: 0,
		position: 'absolute',
		textAlign: 'center',
		textTransform: 'uppercase',
		top: 20,
		width: '100%',
	},
});
